import React from "react";

import { Grid } from "@mui/material";
import { ProgressBarPreview } from "@src/domains/WidgetLibrary/ProgressBar/ProgressBarPreview";
import { useSelector } from "@src/store";
import { getLibraryOfferProgressBars } from "@src/store/slices/widgets/selectors";
import { GlobalStylesProgressBarVariantList } from "@src/types/widgetVariants";

import { OfferProgressBarFullPageDialog } from "./OfferProgressBarFullPageDialog";

export const OfferProgressBarOverview = () => {
  const widgets = useSelector(getLibraryOfferProgressBars).filter((widget) => {
    const variant = widget.config.desktop?.variant;
    return (
      // @ts-ignore - GlobalStylesProgressBarVariantList is the now supported variants
      variant && GlobalStylesProgressBarVariantList.includes(variant)
    );
  });

  return (
    <Grid
      container
      direction={"column"}
      alignItems={"flex-end"}
      rowSpacing={2}
      columnSpacing={2}
    >
      <Grid
        item
        container
        direction={"row"}
        rowSpacing={4}
        columnSpacing={4}
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",
          gridAutoRows: "1fr",
        }}
      >
        {widgets.map((widget) => (
          <Grid item container key={widget.id}>
            <ProgressBarPreview widget={widget} mode={"input"} />
          </Grid>
        ))}
      </Grid>
      <OfferProgressBarFullPageDialog />
    </Grid>
  );
};
